const PAYMENT_METHODS = [
  {name: 'Stripe', type: 'STRIPE'},
  {name: 'Kassa', type: 'KASSA'},
  {name: 'Wise', type: 'WISE'},
  {name: 'NMB', type: 'NMB'},
  {name: 'Equity', type: 'EQUITY'},
  {name: 'Crypto', type: 'CRYPTO'},
  {name: 'Cash', type: 'CASH'},
  {name: 'Paypal', type: 'PAYPAL'},
  {name: 'NMB CC', type: 'NMB_CC'},
  {name: 'Equity CC', type: 'EQUITY_CC'},
  {name: 'CRDB', type: 'CRDB'},
  {name: 'Exim', type: 'EXIM'},
  {name: 'Stripe UAE', type: 'STRIPE_UAE'},
  {name: 'NBD', type: 'NBD'},
  {name: 'Mashreq', type: 'MASHREQ'},
]

const PAYMENT_METHOD_TYPES_BY_CONTRACT_TYPE = {
  TZ: [
    'STRIPE',
    'KASSA',
    'WISE',
    'NMB',
    'EQUITY',
    'CRYPTO',
    'CASH',
    'PAYPAL',
    'NMB_CC',
    'EQUITY_CC',
    'CRDB',
    'EXIM',
  ],
  UAE: [
    'STRIPE_UAE',
    'NBD',
    'MASHREQ',
  ],
}

export const getPaymentMethodsByContractType = (contractType, includeAll = false) => {
  if (includeAll) return [...PAYMENT_METHODS]

  const availableTypes = PAYMENT_METHOD_TYPES_BY_CONTRACT_TYPE[contractType] || []
  return PAYMENT_METHODS.filter((method) => availableTypes.includes(method.type))
}
